import React from "react";
import Loader from "../loader/Loader";
import Column from "@amzn/meridian/column";
import Select, {SelectOption} from "@amzn/meridian/select";
import {versionString} from "../util/Util";
import Text from "@amzn/meridian/text";
import Button from "@amzn/meridian/button";
import Modal from "@amzn/meridian/modal";

const RollbackModal = ({
    showRollbackModal,
    setShowRollbackModal,
    isVersionsLoading,
    selectedVersion,
    setSelectedVersion,
    rollBackVersions,
    loadRollbackDataToDraft,
    intl
}) => {
    return (<Modal
        title="Select a version to rollback"
        open={showRollbackModal}
        onClose={() => {
            setShowRollbackModal(false);
        }}
        scrollContainer="viewport"
        closeLabel="Close"
    >
        {isVersionsLoading ? <Loader/> :
            <Column alignmentHorizontal="right">
                <Select
                    value={selectedVersion}
                    onChange={setSelectedVersion}
                    placeholder="Select a version to rollback"
                    width={300}>
                    {rollBackVersions.map((version, index) => {
                        return (
                            <SelectOption
                                key={index}
                                value={version.rangeKey}
                                label={`${versionString(intl, version.rangeKey, version.alias)}`}
                            />
                        );
                    })}
                    {!rollBackVersions.length ? (
                        <Column alignmentVertical="center" spacing="100" spacingInset="100">
                            <Text alignment="center"> No Versions Available </Text>
                        </Column>) : null
                    }
                </Select>
                <Button
                    onClick={() => {
                        loadRollbackDataToDraft();
                        setShowRollbackModal(false);
                    }}
                    type="primary"
                    size="small"
                    width={100}>
                    Confirm
                </Button>
            </Column>
        }
    </Modal>);
}

export default RollbackModal;


// WEBPACK FOOTER //
// ./src/components/rollback/RollbackModal.js